module.exports = __webpack_public_path__ + "img/olej3.21bf8494.jpg";